import { Button, Container, Typography, Box, useMediaQuery } from '@mui/material'
import React, { useState, useEffect } from 'react'
import bgImage from '../../../../assets/CCImages/bg-title-page.png'
import { personalCreditCardAdapter } from '../auxiliarData/personalCreditCardInfo'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  getCardInfoById,
  setComparison,
  setInitialCard,
  setOpenModal,
  setSelectedCard,
  setTableComparison,
  startNewApplication
} from './store'
import { CARD_POSITION } from './options'
import { comparisonAdapter } from '../../../adapters'
import AAdvantageModal from './AAdvantageModal'
import { useTheme } from '@material-ui/core'
import { useStyles } from './styles/CreditCardComparisonStyle'
import ComparisonSection from './ComparisonSection'
import MobileCardCarousel from './components/MobileCardCarousel'
import MobileCardDetails from './components/MobileCardDetails'

const CreditCardComparison = ({ setComparisson }) => {
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { selectedCC, catalog } = useSelector(
    (state) => state.availableCreditCard
  )
  const { cardOne, cardTwo, cardThree, comparison, tableComparison } = useSelector((state) => state.comparison)

  const dispatch = useDispatch()

  const [cards, setCards] = useState([])
  const [activeCardIndex, setActiveCardIndex] = useState(0)
  const classes = useStyles()

  useEffect(() => {
    if (catalog) {
      const cards = personalCreditCardAdapter(catalog.options)
      setCards(cards)
    }
  }, [catalog])

  useEffect(() => {
    selectedCC.map((cc, position) =>
      dispatch(
        getCardInfoById({ id: cc, carPosition: CARD_POSITION[position + 1] })
      )
    )
  }, [selectedCC, dispatch])

  useEffect(() => {
    const comparison = [cardOne, cardTwo, cardThree].filter(
      (cc) => cc?.id !== null && cc?.id !== undefined
    )
    dispatch(setComparison(comparison))
  }, [cardOne, cardTwo, cardThree, dispatch])

  useEffect(() => {
    const comparisonFiltered = comparison.filter((cc) => cc?.id !== null)
    if (comparisonFiltered.length >= 2) {
      const comparisonData = comparisonAdapter(comparisonFiltered)
      dispatch(setTableComparison(comparisonData))
    }
  }, [comparison, dispatch])

  const handleSelectCard = (card) => {
    dispatch(setSelectedCard(card))

    if (card.requiredAA === false) {
      dispatch(startNewApplication({ selectedCardId: card.id })).then(
        (response) => {
          if (response.error) return
          navigate('/credit-card/personal-information-review')
        }
      )
      return
    }

    dispatch(setOpenModal(true))
  }

  const handleCardChange = (index) => {
    setActiveCardIndex(index)
  }

  const filteredCards = cards.filter((cc) => selectedCC.includes(cc.id))

  const prepareMobileCardDetails = () => {
    if (!comparison || comparison.length === 0 || !tableComparison) return null

    const currentCard = comparison[activeCardIndex]
    if (!currentCard) return null

    // Extract data specific to the active card
    const features = tableComparison.features.map((feature) => ({
      title: feature.title,
      value: feature.values[activeCardIndex],
      key: feature.title.replace(/\s+/g, '_').toLowerCase()
    }))

    const benefits = tableComparison.benefits.map((benefit) => ({
      title: benefit.title,
      value: benefit.values[activeCardIndex],
      key: benefit.title.replace(/\s+/g, '_').toLowerCase()
    }))

    return { card: currentCard, features, benefits }
  }

  const renderDesktopCards = () => (
    <Box 
      className={classes.cardGridContainer}
      style={{ gridTemplateColumns: `repeat(${comparison?.length > 0 ? comparison.length + 1 : 1}, 1fr)` }}
    >
      <Box display={{ xs: 'none', sm: 'block' }}></Box>
      {filteredCards.map((selected) => (
        <div className={classes.cardItemContainer} key={selected.id}>
          <div className={classes.cardImageContainer}>
            <img
              src={selected.cardImage}
              alt={`${selected.name || 'Credit'} card`}
              className={classes.cardImage}
              width={253}
              height={162}
              style={{ objectFit: 'contain' }}
            />
          </div>
          <Button
            variant="contained"
            className={classes.selectCardButton}
            onClick={() => handleSelectCard(selected)}
            fullWidth
          >
            Select This Card
          </Button>
        </div>
      ))}
    </Box>
  )

  return (
    <>
      <Container maxWidth='lg' className={classes.container}>
        <div
          className={classes.titleBackground}
          style={{
            backgroundImage: `url(${bgImage})`
          }}
        >
          <Typography color='#fff' variant='h5'>
            Compare credit cards
          </Typography>
        </div>

        {isMobile ? (
          <MobileCardCarousel 
            cards={filteredCards}
            onSelectCard={handleSelectCard}
            onCardChange={handleCardChange}
          />
        ) : (
          renderDesktopCards()
        )}

        {comparison.length > 0 && (
          <>
            {isMobile ? (
              <MobileCardDetails {...prepareMobileCardDetails()} />
            ) : (
              <Box className={classes.comparisonContainer}>
                <ComparisonSection title='Compare Features' data={tableComparison.features} />
                <ComparisonSection title='Benefits' data={tableComparison.benefits} />
              </Box>
            )}
          </>
        )}

        <div className={classes.goBackButtonContainer}>
          <Button
            variant="outlined"
            className={classes.goBackButton}
            onClick={() => {
              setComparisson(false)
              dispatch(setInitialCard())
            }}
          >
            GO BACK TO ALL CREDIT CARDS
          </Button>
        </div>
      </Container>

      <AAdvantageModal />
    </>
  )
}

export default CreditCardComparison
